import React from "react";

// Import all the new child components
import VendorLogin from "./loginVendor";

import VendorForgotPassword from "./ForgetPassword";
;
import RequestConfirmed from "./requestConfirmed";
import NewPassword from "./newPassword";
import PasswordResetConfirmed from "./PasswordResetConfirmed";
// This component is the main layout and orchestrator
export default function VendorLoginPopup({
  state,
  styles = {},
  props,
  handlers,
  popupType,
  isdDropdownStyles,
  PromotionBannerCss,
  siteData,
  router,
  isMobile
}) {
  const renderForm = () => {

 
    switch (popupType.popupPage) {
      case "vendor_login":
        return (
          <VendorLogin state={state} styles={styles} PromotionBannerCss={PromotionBannerCss} handlers={handlers} siteData={siteData}    isMobile={isMobile} />
        );
     
      case "VendorForgotPassword":
        return (
          <VendorForgotPassword state={state} styles={styles} handlers={handlers} PromotionBannerCss={PromotionBannerCss} siteData={siteData}    isMobile={isMobile}/>
        );
      case 'RequestConfirmed':
        return <RequestConfirmed state={state} styles={styles} handlers={handlers} PromotionBannerCss={PromotionBannerCss} siteData={siteData}    isMobile={isMobile}/>;
      case "NewPassword":
        return (
          <NewPassword state={state} styles={styles} handlers={handlers} router={router} PromotionBannerCss={PromotionBannerCss} siteData={siteData}    isMobile={isMobile}/>
        );
      case 'PasswordResetConfirmed':
        return( <PasswordResetConfirmed state={state} styles={styles} handlers={handlers} PromotionBannerCss={PromotionBannerCss} siteData={siteData}    isMobile={isMobile}/>);
       // Add cases for "SignUp", etc. here
      default:
        // Default to email login to be safe
        return (
          <VendorLogin state={state} styles={styles} PromotionBannerCss={PromotionBannerCss} handlers={handlers} siteData={siteData}    isMobile={isMobile} />
        );
    }
  };

  return (
    <div className={styles.login_flex}>
      
      <div className={styles.form_flex}>{renderForm()}</div>
    </div>
  );
}
